module.exports = __webpack_public_path__ + "img/電気回路_1_3_5.8bec90a1.png";